import { render } from "./ak.vue?vue&type=template&id=689a6ede&scoped=true&ts=true"
import script from "./ak.vue?vue&type=script&lang=ts"
export * from "./ak.vue?vue&type=script&lang=ts"

import "./ak.vue?vue&type=style&index=0&id=689a6ede&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689a6ede"]])

export default __exports__